import { GameKillerService } from "@/services/gameKiller/gameKiller.service"
const _gameKillerService = new GameKillerService();

const activeGameKillerAction = ({ commit }, { spaceId, callback, callbackError }) => {
    _gameKillerService
        .activeGameKiller(spaceId)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const disableGameKillerAction = ({ commit }, { spaceId, callback, callbackError }) => {
    _gameKillerService
        .disableGameKiller(spaceId)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const killPlayerGameKillerAction = ({ commit }, { spaceUserId, callback, callbackError }) => {
    _gameKillerService
        .killPlayerGameKiller(spaceUserId)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const reportPlayerGameKillerAction = ({ commit }, { spaceUserId, data, callback, callbackError }) => {
    _gameKillerService
        .reportPlayerGameKiller(spaceUserId, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const votePlayerGameKillerAction = ({ commit }, { spaceId, data, callback, callbackError }) => {
    _gameKillerService
        .votePlayerGameKiller(spaceId, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callbackError(error);
        });
};

const setGameKillerDataAction = ({ commit }, payload: any): void => {
    commit("setGameKillerData", payload);
};

const setGameKillerTimerVoteAction = ({ commit }, payload: any): void => {
    commit("setGameKillerTimerVote", payload);
};

const setGameKillerTimerReportAction = ({ commit }, payload: any): void => {
    commit("setGameKillerTimerReport", payload);
};

const setGameKillerUserVotedAction = ({ commit }, payload: any): void => {
    commit("setGameKillerUserVoted", payload);
};

const setGameKillerTimerKillerAction = ({ commit }, payload: any): void => {
    commit("setGameKillerTimerKiller", payload);
};

const setGameKillerLastDeadAction = ({ commit }, payload: any): void => {
    commit("setGameKillerLastDead", payload);
};

const setGameKillerTimerBanAction = ({ commit }, payload: any): void => {
    commit("setGameKillerTimerBan", payload);
};

export default {
    activeGameKillerAction,
    disableGameKillerAction,
    killPlayerGameKillerAction,
    votePlayerGameKillerAction,
    reportPlayerGameKillerAction,
    setGameKillerDataAction,
    setGameKillerTimerVoteAction,
    setGameKillerTimerReportAction,
    setGameKillerUserVotedAction,
    setGameKillerTimerKillerAction,
    setGameKillerLastDeadAction,
    setGameKillerTimerBanAction,
}